import {API_GET_ALL_USER_ROLES} from 'common/constants/apis';
import {CRASHLYTICS_AUTH_ERROR} from 'common/constants/errors';
import {IRoleListResp} from 'common/interfaces/irole';
import UILogger, {LogRecordType, LogSeverityType} from 'common/utils/logger';
import httpClient from './config';

export const getRoleList = async (): Promise<IRoleListResp> => {
  UILogger.log('RoleService: Getting roles, ');
  return httpClient
    .get(API_GET_ALL_USER_ROLES)
    .then(res => {
      UILogger.log('UserService: Getting roles done, ', res.data);
      if (res.status === 200) {
        return res.data;
      }
      return {status: {success: false}} as IRoleListResp;
    })
    .catch(error => {
      if (error?.response?.status !== 401) {
        UILogger.log(
          {
            recordType: LogRecordType.CRASHLYTICS,
            severity: LogSeverityType.ERROR,
            error,
            tag: CRASHLYTICS_AUTH_ERROR,
          },
          'Error in getting roles',
          error,
        );
      }
      UILogger.log('Error in getting roles. status:', error?.response?.status);
      return {status: {success: false}} as IRoleListResp;
    });
};
